import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { completeGoogleAuth } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const session_id = m[1];
    (async () => {
      try {
        await completeGoogleAuth(session_id);
        // remove hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard");
      } catch (err) {
        toast.error("Google sign-in failed");
        navigate("/login");
      }
    })();
  }, [completeGoogleAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="text-center">
        <div className="font-display text-2xl tracking-widest text-primary-accent mb-3">SIGNING YOU IN</div>
        <div className="text-zinc-500 text-sm uppercase tracking-widest">One moment…</div>
      </div>
    </div>
  );
}
